import { g as h } from "./_commonjsHelpers-es.js";
var o = { exports: {} };
function f() {
}
f.prototype = {
  on: function(e, n, r) {
    var t = this.e || (this.e = {});
    return (t[e] || (t[e] = [])).push({
      fn: n,
      ctx: r
    }), this;
  },
  once: function(e, n, r) {
    var t = this;
    function s() {
      t.off(e, s), n.apply(r, arguments);
    }
    return s._ = n, this.on(e, s, r);
  },
  emit: function(e) {
    var n = [].slice.call(arguments, 1), r = ((this.e || (this.e = {}))[e] || []).slice(), t = 0, s = r.length;
    for (t; t < s; t++)
      r[t].fn.apply(r[t].ctx, n);
    return this;
  },
  off: function(e, n) {
    var r = this.e || (this.e = {}), t = r[e], s = [];
    if (t && n)
      for (var i = 0, v = t.length; i < v; i++)
        t[i].fn !== n && t[i].fn._ !== n && s.push(t[i]);
    return s.length ? r[e] = s : delete r[e], this;
  }
};
o.exports = f;
o.exports.TinyEmitter = f;
var p = o.exports;
const a = /* @__PURE__ */ h(p);
export {
  a as E
};
